import { HTTP_YAF } from "../axios";
// 平台列表
export const postSelectedList = (params) => {
  return HTTP_YAF.post("/login/login/selected_list", params);
};
